import { Route } from '@tanstack/react-router'

import { Settings } from '@components/Settings/Settings'

import { appIndex } from './App'

export const settingsRoute = new Route({
    getParentRoute: () => appIndex,
    path: 'settings',
    component: Settings,
})
